export default __webpack_public_path__ + "8010ce7bde485e188fd8a68af2f2341b.png";